import React, { Fragment } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  learnerActions,
  selectCanEditProgress,
  selectSkillById,
  selectSkillScoreChange,
} from "@hubcapp/state";

import { SkillRowStateProviderProps } from "./types";
import { useTealium } from "@hubcapp/context";
import SkillRow from "./SkillRow";

const SkillRowStateProvider: React.FC<SkillRowStateProviderProps> = ({
  skillId,
}: SkillRowStateProviderProps) => {
  const dispatch = useDispatch();
  const skill = useSelector(selectSkillById(skillId));
  const difference = useSelector(selectSkillScoreChange(skillId));
  const enableEdit = useSelector(selectCanEditProgress);
  const { trackEvent } = useTealium();

  return (
    <Fragment key={skillId}>
      <SkillRow
        skillName={skill?.skillName || ""}
        skillScore={skill?.score || 0}
        difference={difference}
        enableEdit={enableEdit}
        increaseScore={() => {
          if ((skill?.score || 0) > 4) {
            return;
          }
          const score = (skill?.score || 0) + 1;
          trackEvent({
            eventCategory: "View Learner - Progress",
            eventAction: "Interaction",
            eventLabel: `${skill?.skillName} - Increase ${score}`,
          });

          dispatch(
            learnerActions.changeSkillScore({
              skillId,
              score: (skill?.score || 0) + 1,
            }),
          );
        }}
        decreaseScore={() => {
          if ((skill?.score || 0) - 1 < 0) {
            return;
          }
          const score = (skill?.score || 0) - 1;
          trackEvent({
            eventCategory: "View Learner - Progress",
            eventAction: "Interaction",
            eventLabel: `${skill?.skillName} - Decrease ${score}`,
          });

          dispatch(
            learnerActions.changeSkillScore({
              skillId,
              score: (skill?.score || 0) - 1,
            }),
          );
        }}
      />
    </Fragment>
  );
};

export default SkillRowStateProvider;
